// overwrite the core environment
export const custom_environment = {
  // can be used to change environment for debugging
};